import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ParishBarChart({ data }) {
  const chartData = {
    labels: data.map(d => d.parish),
    datasets: [{
      label: 'Offenses by Parish',
      data: data.map(d => d.count),
      backgroundColor: 'rgba(75, 192, 192, 0.6)', // Teal color
      borderColor: 'rgba(75, 192, 192, 1)',
      borderWidth: 1,
    }],
  };

  const options = {
    indexAxis: 'y', // This makes the bar chart horizontal
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend as the title is clear enough
      },
      title: {
        display: true,
        text: 'Offenses by Parish',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 1, // Ensure whole numbers for the count
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
}

export default ParishBarChart;